import { flattenColumns } from './flattenColumns';

/**
 * Process export fields to temporarily set visibility for export 
 * @param {*} columns The structured columns array
 * @param {*} columnNames An array to collect the names of columns to be exported
 * @param {*} persistenceKey  A key used for state persistence
 * @param {*} storageGetter A function to get stored state
 */
// eslint-disable-next-line no-unused-vars
export function processExportFields(columns, columnNames = [], persistenceKey, storageGetter) {
    const flat = flattenColumns(columns);
    // columns is structured; this will mutate columns to temporarily set visible=true for required exportFields
    const recurse = (cols) => {
        cols.forEach((element) => {

            if (element.columns && Array.isArray(element.columns)) {
                recurse(element.columns);
            } else if (element.groupIndex !== undefined) {
                if (element.exportFields && Array.isArray(element.exportFields) && element.visible) {
                    element.exportFields.forEach((exportColumn) => {

                        const hIndex = flat.findIndex((x) => x.caption === exportColumn.label && !x.cellTemplate);

                        if (hIndex > -1 && !flat[hIndex].visible) {
                            flat[hIndex].visible = true;
                            flat[hIndex].visibleIndex = element.visibleIndex; // assign visibleIndex based on current position in flat array
                            columnNames.push(exportColumn.dataField);
                        }
                    });
                    element.allowExporting = false;
                } else if (element.cellTemplate === 'Status') {
                    element.caption = 'Status';
                    columnNames.push(element.dataField);
                }
            }
        });
    };


    recurse(columns);

    return columns;
}